<div *ngIf="!isLoader" class="agpr-contextualPanel">
    <agpr-scroll-panel>
        <div id="rightMenu-Accordion" class="agpr-contextualPanel-customAccordion">
            <!-- @Todo the details will show after save story-->
            <div class="agpr-contextualPanel-inputGroup agpr-contextualPanel-detailsListBlock">
                <agpr-panel
                    header="Details"
                    *ngIf="storyResponseModel.createdUserId && statusId">
                    <ul class="agpr-contextualPanel-detailsList" *ngIf="storyResponseModel.createdUserId">
                        <li class="agpr-contextualPanel-detailsListItem">Created By</li>
                        <li class="agpr-contextualPanel-detailsListItem">{{ storyCreatedBy }}</li>
                    </ul>
                    <ul class="agpr-contextualPanel-detailsList" *ngIf="storyResponseModel.createdDate > 0">
                        <li class="agpr-contextualPanel-detailsListItem">Date Created</li>
                        <li class="agpr-contextualPanel-detailsListItem">{{ getFormattedTime(storyResponseModel.createdDate, preferences ? preferences.timeZone : "UTC")}}</li>
                    </ul>
                    <ul class="agpr-contextualPanel-detailsList" *ngIf="storyResponseModel.modifiedUserId">
                        <li class="agpr-contextualPanel-detailsListItem">Modified By</li>
                        <li class="agpr-contextualPanel-detailsListItem">{{ storyModifiedBy }}</li>
                    </ul>
                    <ul class="agpr-contextualPanel-detailsList" *ngIf="storyResponseModel.modifiedDate > 0">
                        <li class="agpr-contextualPanel-detailsListItem">Last modified</li>
                        <li class="agpr-contextualPanel-detailsListItem">{{ getFormattedTime(storyResponseModel.modifiedDate, preferences ? preferences.timeZone : "UTC")}}</li>
                    </ul>
                </agpr-panel>
            </div>
            <div class="agpr-contextualPanel-inputGroup">
                <agpr-panel header="Components" >
                    <div class="agpr-storyItems">
                        <agpr-button
                            class="agpr-storyItems-companyLogo"
                            id="story.addLogo"
                            [style]="buttonTypes.secondary"
                            icon="fa-regular fa-duotone fa-circle-star"
                            label="Company Logo"
                            [disabled]="showLogoButton"
                            (click)="imageClick('logo')"
                        >
                        </agpr-button>
                        <agpr-button
                            id="story.addText"
                            [style]="buttonTypes.secondary"
                            icon="fa-solid fa-align-left"
                            label="Text"
                            [disabled]="remainingTextContents <= 0"
                            (click)="textClick()"
                        >
                            <span class="agpr-storyItem-remaining">
                                ({{ remainingTextContents }})
                            </span>
                        </agpr-button>
                        <agpr-button
                            id="story.addImage"
                            [style]="buttonTypes.secondary"
                            icon="fa-regular fa-duotone fa-image"
                            label="Image"
                            [disabled]="remainingImageContents <= 0"
                            (click)="imageClick('image')"
                        >
                            <span class="agpr-storyItem-remaining">
                                ({{ remainingImageContents }})
                            </span>
                        </agpr-button>
                        <agpr-button
                            id="story.addAbout"
                            [style]="buttonTypes.secondary"
                            icon="fa-regular fa-duotone fa-screen-users"
                            label="About Us"
                            [disabled]="aboutUsButton"
                            (click)="toggleAboutUs()"
                        >
                        </agpr-button>
                        <agpr-button
                            id="story.addLink"
                            [style]="buttonTypes.secondary"
                            icon="fa-regular fa-duotone fa-link"
                            label="Links"
                            [disabled]="linkButton"
                            (click)="toggleLink()"
                        >
                        </agpr-button>
                    </div>
                </agpr-panel>
            </div>
            <ng-content></ng-content>
            <div class="agpr-contextualPanel-inputGroup agpr-contextualPanel-scheduleStoryBlock" *ngIf="enableDeliveryScheduler()">
                <agpr-panel header="Schedule">
                    <agpr-delivery-scheduler
                        [inputId]="'newsroomRightSidebar'"
                        [immediateOptionLabel]="localization.publishNow"
                        [futureOptionLabel]="localization.publishLater"
                        [(selectedSchedulingType)]="rightSideBarInterface.deliverySchedulingType"
                        [(deliveryDate)]="rightSideBarInterface.publishDate"
                        [(time)]="rightSideBarInterface.publishTime"
                        [minDate] = "minDate"
                        [disabled] = "statusId === this.statusEnum.PUBLISHED"
                        [minDateValidationMessage]="'Please pick a date in the future.'"
                        (deliveryDateChange) ="scheduledDateSelected($event)"
                        (selectedSchedulingTypeChange) ="schedulingTypeSelected()"
                        (timeChange) = "timeChanged($event)"
                    ></agpr-delivery-scheduler>
                </agpr-panel>
            </div>
            <div class="agpr-contextualPanel-inputGroup agpr-contextualPanel-subjectBlock">
                <agpr-panel header="Subjects">
                    <agpr-autocomplete-chips
                        placeholder="Select Subject"
                        field="label"
                        [disabled]="subjectDropDownDisabled"
                        [autocompleteOptions]="autocompleteOptions"
                        [(ngModel)]="selectedSubjects"
                        (ngModelChange)="setSubjects()"
                        [ariaLabel]="Subjects"
                    ></agpr-autocomplete-chips>
                </agpr-panel>
            </div>
            <!-- @Todo the reserved URL will show after publish story-->
            <div class="agpr-contextualPanel-inputGroup">
                <agpr-panel
                    *ngIf="enableReservedUrl()"
                    header="Reserved Url">
                    <div class="agpr-contextualPanel-reservedUrl">
                        {{ reservedUrl }}
                    </div>
                </agpr-panel>
                <agpr-panel
                    *ngIf="storyResponseModel.statusId == statusEnum.PUBLISHED"
                    header="PUBLISHED URL(S)">
                    <div class="agpr-contextualPanel-reservedStoryUrl" *ngIf="storyResponseModel.statusId == statusEnum.PUBLISHED">
                        <ul class="agpr-contextualPanel-reservedStoryUrlList">
                            <li class="agpr-contextualPanel-reservedStoryUrlListItem">
                                <a class="agpr-contextualPanel-reservedStoryUrlLink" href="{{ reservedUrl }}" target="_blank">
                                    {{ reservedUrl }}
                                </a>
                            </li>
                        </ul>
                    </div>
                </agpr-panel>
            </div>
        </div>
    </agpr-scroll-panel>
</div>
